/**
 * This is a "controlled" Select component, made to work with
 * react-hooks-form.
 */
import React from 'react';
import {
  Controller,
  type FieldValues,
  type UseControllerProps,
} from 'react-hook-form';
import Select, { type SelectProps } from '@mui/material/Select';

type ControlledSelectProps<T extends FieldValues> = SelectProps &
  UseControllerProps<T>;

export default function ControlledSelect<T extends FieldValues>({
  children = [],
  control,
  defaultValue,
  multiple = false,
  name,
  rules = {},
  shouldUnregister = false,
  ...props
}: ControlledSelectProps<T>) {
  return (
    <Controller
      defaultValue={defaultValue}
      rules={rules}
      control={control}
      name={name}
      render={({ field: { onChange, value, onBlur } }) => (
        <Select
          notched={
            !!(Array.isArray(value)
              ? value.length
              : typeof value === 'boolean' || value)
          }
          {...{ ...props, multiple, value, onChange, onBlur }}
        >
          {children}
        </Select>
      )}
      shouldUnregister={shouldUnregister}
    />
  );
}
